import { render, staticRenderFns } from "./GtmLoader.vue?vue&type=template&id=6fbb83d9&"
import script from "./GtmLoader.vue?vue&type=script&lang=js&"
export * from "./GtmLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports